export const MEMBERSHIP_STATUS_CONFIG = {
  INVITED: { label: "Invited", color: "default" },
  ACTIVE: { label: "Active", color: "success" },
  INACTIVE: { label: "Inactive", color: "default" },
  PENDING: { label: "Pending", color: "processing" },
  SUSPENDED: { label: "Suspended", color: "warning" },
  LAPSED: { label: "Lapsed", color: "error" },
} as const

export type MembershipStatusDisplayKey = keyof typeof MEMBERSHIP_STATUS_CONFIG

const UNKNOWN_MEMBERSHIP_STATUS_DISPLAY = {
  label: "Unknown",
  color: "default",
} as const

export const getMembershipStatusDisplay = (status?: string | null) => {
  if (status && status in MEMBERSHIP_STATUS_CONFIG) {
    return MEMBERSHIP_STATUS_CONFIG[status as MembershipStatusDisplayKey]
  }

  return UNKNOWN_MEMBERSHIP_STATUS_DISPLAY
}
